module.exports = __webpack_public_path__ + "static/img/story-bg.6e17da0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/brand-culture/story-bg.jpg
// module id = op4v
// module chunks = 1